<div class="table">
    <p-table #tt [value]="productLogs" [resizableColumns]="true" [autoLayout]="true" [paginator]="true"
    [rows]="numberOfRows" [pageLinks]="3" [rowsPerPageOptions]="isDialog? null : [10,20,30,50,100]">
        <ng-template pTemplate="header">
            <tr>
                <th>Data/hora</th>
                <th>Usuário</th>
                <th>Origem</th>
                <th>Produto/Serviço</th>
                <th>Ação</th>
                <th>Visualizar</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-productLog>
            <tr>
                <td>{{productLog.logTime | date: 'dd/MM/yyyy - HH:mm'}}</td>
                <td [pTooltip]="productLog.user ? productLog.user.fullName : ''" tooltipPosition="top">{{productLog.user ? productLog.user.username : ''}}</td>
                <td>{{productLog.origin}}</td>
                <td>{{productLog.name}}</td>
                <td>{{productLog.operationLog | translate}}</td>
                <td>
                    <div class="table-action" (click)="openProductLogDialog(productLog)" pTooltip="Visualizar" *ngIf="productLog.oldDatas"
                        tooltipPosition="bottom">
                        <i class="pi pi-eye"></i>
                    </div>
                </td>
            </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="7">
                    Nenhum log encontrado
                </td>
            </tr>
        </ng-template>

    </p-table>
</div>
